export default function ContactTrustBar({ items }) {
  return (
    <div className="contact-section__trust-bar">
      {items.map(({ Icon, title, text }, index) => (
        <div
          className={`contact-section__trust-item reveal-on-scroll reveal-on-scroll--scale reveal-delay-${
            (index % 4) + 1
          }`}
          key={title}
        >
          <span>
            <Icon />
          </span>

          <div>
            <strong>{title}</strong>
            <small>{text}</small>
          </div>
        </div>
      ))}
    </div>
  );
}